// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.confirmation-by-section__cont[data-v-a590c9be] {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  margin-top: 10px;\n  margin-bottom: -15px;\n}\n.confirmation-by-section__datepicker[data-v-a590c9be] {\n  width: 100%;\n  max-width: 100px;\n}\n.confirmation-by-section__timepicker[data-v-a590c9be] {\n  width: 100%;\n  max-width: 70px;\n}\n", ""]);
// Exports
module.exports = exports;
